import { FusionError, serializeFusionError } from '@fusion-advantage/backcompat'
import { CloudToDeviceOfflineTableDrugProductBody } from "../redux/syncthunk/ZCloudToDevice"
import { bulkInsert } from "./bulkInsert"
import { sqlQuery, sqlRun } from "./ldb"
import { DrugProduct } from "@fusion-advantage/backcompat"
import { err, ok, Result } from "neverthrow"
import { selectAllText } from "./LdbBrowser"

export const selectAllDrugProducts = async (): Promise<Result<DrugProduct[], FusionError>> => {
	let r = await sqlQuery<DrugProduct>(`
		select ID, Name
		  from drugProduct
	`)
	if(r.isErr()) {
		return err(serializeFusionError('selectAllDrugProducts', r.error))
	}
	return ok(r.value)
}

export const selectAllDrugProductText = async (): Promise<string> => {
	return selectAllText('drugProduct', ['ID', 'Name'])
}

export const ldbDrugProductBulkInsert = async (body: CloudToDeviceOfflineTableDrugProductBody): Promise<Result<void, FusionError>> => {
	let r = await sqlRun('delete from drugProduct')
	if(r.isErr()) {
		return err(serializeFusionError('ldbDrugProductBulkInsert', r.error))
	}
	let params = []
	for (let m of body.Products) {
		params.push(m.ID, m.Name)
	}
	r = await bulkInsert('drugProduct', params, 2)
	if(r.isErr()) {
		return err(serializeFusionError('ldbDrugProductBulkInsert', r.error))
	}
	return ok()
}

export const selectDrugProductsByQuery = async (strQuery: string): Promise<Result<DrugProduct[], FusionError>> => {
	const excludedWords = [
		'potassium', 'pharm', 'days', 'gram', 'CAPSULE', 'tab', 'mfg', 'mfg:', 'tablet', 'take', 'mouth',
		'times', 'daily', 'minutes', 'before', 'meals', 'two', '(two)', 'nightly', 'every', '.Insulin',
		'0.25%', '0.5%', '0.9%'
	]

	const words = strQuery.split(' ').filter(word => word.length > 3 && isNaN(Number(word)) && !excludedWords.includes(word))

	const query = `
		WITH fndInputTbl AS (
			SELECT rowid, strValue
			FROM (
				SELECT row_number() OVER() AS rowid, value AS strValue
				FROM (
					SELECT DISTINCT value
					FROM json_each('["${words.join('","')}"]')
				)
			)
		),
		IDentified AS (
			SELECT MAX(p.ID) AS ID
			FROM drugProduct p
			INNER JOIN fndInputTbl tbl ON p.Name LIKE tbl.strValue || '%'
				-- AND p.Name NOT LIKE '%potassium%'
				-- AND p.Name NOT LIKE '%intravenous%'
			GROUP BY p.Name
		)
		SELECT p.ID, p.Name
		FROM IDentified pid
		INNER JOIN drugProduct p ON p.ID = pid.ID
		ORDER BY LENGTH(p.Name) ASC
	`

	let r = await sqlQuery<DrugProduct>(query)
	if(r.isErr()) {
		return err(serializeFusionError('selectDrugProductsByQuery', r.error))
	}
	return ok(r.value)
}
